import SectionFeatureColumns from './SectionFeatureColumns';
export default SectionFeatureColumns;
